export default function AmbientBackground() {
  return (
    <div className="ambient-background" aria-hidden="true">
      <div className="ambient-orb ambient-orb--lilac" />
      <div className="ambient-orb ambient-orb--blue" />
      <div className="ambient-orb ambient-orb--peach" />
      <div className="ambient-orb ambient-orb--cream" />
      <div className="ambient-sheen" />
      <div className="ambient-grain" />
    </div>
  );
}
